import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { fetchCatalog } from 'redux/catalog';
import { getLoginState } from 'redux/user';

/**
 * * useCatalog - Custom hook to fetch data from catalog, store in redux
 *
 * @return {object} catalog data from redux
 * */
export default function useCatalog() {
  // Get redux dispatch function
  const dispatch = useDispatch();
  const catalog = useSelector((state) => state.catalog);
  const user = useSelector((state) => state.user);
  const isLoggedIn = useSelector(getLoginState);
  const location = useLocation();
  const didMount = useRef(false);

  // Only re-fetch catalog when certain user values change after initial mount
  useEffect(() => {
    if (catalog.isCatalogFetched && didMount.current) {
      dispatch(fetchCatalog(user.zip, user.email, isLoggedIn, true, user.userSetEnvironment));
    } else if (!didMount.current) didMount.current = true;
    /* eslint-disable-next-line */
  }, [dispatch, user.zip, user.email, user.userSetEnvironment, isLoggedIn]);

  // Only fetch catalog on page navigation if catalog and is not yet fetched
  useEffect(() => {
    if (!catalog.isCatalogFetched) {
      dispatch(fetchCatalog(user.zip, user.email, isLoggedIn, false, user.userSetEnvironment));
    }
    /* eslint-disable-next-line */
  }, [dispatch, location]);

  return catalog;
}
